import _createClass from '@babel/runtime/helpers/createClass';
import _classPrivateFieldGet from '@babel/runtime/helpers/classPrivateFieldGet';

var _data = new WeakMap();

var FakeStorage = /*#__PURE__*/function () {
  function FakeStorage() {
    _data.set(this, {
      writable: true,
      value: new Map()
    });
  }

  var _proto = FakeStorage.prototype;

  _proto.key = function key(n) {
    n = Number.parseInt(n, 10);

    var iterator = _classPrivateFieldGet(this, _data).keys();

    var i = 0;
    var result = iterator.next();

    while (!result.done) {
      if (i === n) {
        return result.value;
      }

      i += 1;
      result = iterator.next();
    }

    return null;
  };

  _proto.getItem = function getItem(key) {
    var _classPrivateFieldGet2;

    return (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _data).get("" + key)) != null ? _classPrivateFieldGet2 : null;
  };

  _proto.setItem = function setItem(key, value) {
    _classPrivateFieldGet(this, _data).set("" + key, "" + value);
  };

  _proto.removeItem = function removeItem(key) {
    _classPrivateFieldGet(this, _data)["delete"]("" + key);
  };

  _proto.clear = function clear() {
    _classPrivateFieldGet(this, _data).clear();
  };

  _createClass(FakeStorage, [{
    key: "length",
    get: function get() {
      return _classPrivateFieldGet(this, _data).size;
    }
  }]);

  return FakeStorage;
}();

export default FakeStorage;
//# sourceMappingURL=index.esm.js.map
